import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { setBookingField, showTeamMenu, showTimeMenu, setTeamAndBook, createBooking } from '../../store/ResourceStore';
import Unit from './Unit';

const TeamChooser = () => {
    const dispatch = useDispatch();
    
    const resState = useSelector((state) => state.resourceState);
    const teamState = useSelector((state) => state.teamState);
    const personState = useSelector((state) => state.personState);

    const showMenu = resState.showTeamMenu;
    if (!showMenu) return null;

    const units = resState.units;
    const teams = teamState.teams;
    const model = resState.createBooking;

    const administration = teams.find(x => x.id === 46);
    const pladsmen = teams.find(x => x.id === 45);
    const workshop = teams.find(x => x.id === 44);
    const recycle = teams.find(x => x.id === 43);
    const rats = teams.find(x => x.id === 42);
    const sports = teams.find(x => x.id === 41);
    const animal = teams.find(x => x.id === 40);
    const garden6 = teams.find(x => x.id === 38);
    const garden5 = teams.find(x => x.id === 37);
    const garden4 = teams.find(x => x.id === 36);
    const garden2 = teams.find(x => x.id === 35);
    const garden1 = teams.find(x => x.id === 34);
    const buildings = teams.find(x => x.id === 32);

    const unitBooking = units.find(x => x.id === model.unitId);
    const renderTeam = (team) => {
        return(
            <div key={team.id} className={`team${model.teamId === team.id ? '' : ' active'}`} onClick={() => dispatch(setBookingField({ field: 'teamId', value: team.id }))}>
                <div className='text'>{team.description}</div>
            </div>
        )
    };

    const renderRow = (mainTeam, teams) => {
        return(
            <div className='team-row'>
                <h2>{mainTeam.name}</h2>
                {renderTeam(mainTeam)}
                {teams && teams.map(x => renderTeam(x))}
            </div>
        )
    };

    return(
        <div className='dialog-overlay' onClick={() => dispatch(showTeamMenu(false))}>
            <div className='dialog teamchooser' onClick={(e) => e.stopPropagation()}>
                <div className='unit-container'>
                    <Unit unit={unitBooking} hideText noMenu hideName/>
                    <div className='clearfix'/>
                </div>
                <h1>Hvem reserverer "{unitBooking.name}"?</h1>
                {renderRow(garden1, [garden2, garden4, garden5, garden6])}
                {renderRow(administration, [animal, sports, rats])}
                {renderRow(buildings)}
                {renderRow(workshop, [pladsmen])}
                {renderRow(recycle)}
                <div className={`dialog-btn${model.teamId ? '' : ' disabled'}`} onClick={
                    () => {
                        dispatch(showTimeMenu(false));
                        dispatch(showTeamMenu(true));
                        dispatch(setTeamAndBook({ teamId: model.teamId }));
                        const cb = { ...model, teamId: model.teamId };
                        dispatch(createBooking({
                            unitId: cb.unitId,
                            teamId: cb.teamId,
                            startTime: cb.startTime,
                            endTime: cb.endTime,
                        }));  
                    }}
                >Done</div>
            </div>
        </div>
    )
};

export default TeamChooser;